import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { typographyCss, colors, cbSemanticCssVars } from "@creditornot/cb-ingredients";
import { pxToRem, configureCssVars } from "@creditornot/cb-utils";
const sizeConfigs = {
  extraTiny: {
    width: 16,
    typography: `
      ${typographyCss.baseFontFamily()}
      text-transform: uppercase;
      font-size: ${pxToRem(8)};
      line-height: ${pxToRem(10)};
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
    `
  },
  tiny: {
    width: 24,
    typography: typographyCss.Overline4()
  },
  small: {
    width: 36,
    typography: typographyCss.Overline3()
  },
  medium: {
    width: 48,
    typography: typographyCss.Overline2()
  },
  large: {
    width: 64,
    typography: typographyCss.Overline1()
  },
  extraLarge: {
    width: 72,
    typography: typographyCss.Overline1()
  }
};
const { cssString: colorCssString, cssVars: colorCssVars } = configureCssVars({
  backgroundColor: {
    light: colors.pepper8,
    dark: colors.salt12
  }
});
const Root = styled.div`
  ${colorCssString}

  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => sizeConfigs[$size].width}px;
  height: ${({ $size }) => sizeConfigs[$size].width}px;
  border-radius: 50%;
  background-color: ${colorCssVars.backgroundColor};
  color: ${cbSemanticCssVars.textSecondary};
  ${({ $size }) => sizeConfigs[$size].typography};
  overflow: hidden;
  cursor: ${({ $clickable }) => $clickable ? "pointer" : "default"};
`;
const AvatarImage = styled.img`
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  border-radius: 50%;
  object-fit: cover;
`;
const Avatar = ({
  imgAlt,
  imgProps,
  imgSizes,
  imgSrc,
  imgSrcSet,
  initials = "",
  size = "small",
  ...rest
}) => /* @__PURE__ */ jsx(Root, { $clickable: !!rest.onClick, $size: size, ...rest, children: imgSrc ? /* @__PURE__ */ jsx(AvatarImage, { ...imgProps, alt: imgAlt, sizes: imgSizes, src: imgSrc, srcSet: imgSrcSet }) : initials });
export {
  Avatar
};
//# sourceMappingURL=index.js.map
